import { useState } from 'react';
import useHttp from '../../hooks/use-http';
import Buttons from '../UI/Buttons/Buttons';
import ActiveComponent from '../ActiveComponent/ActiveComponent';

function Wrapper() {
  const [disableDeklaracije, setDisableDeklaracije] = useState(false);
  const [disableLogo, setDisableLogo] = useState(false);
  const [buttonData, setButtonData] = useState({});
  const [refreshData, setRefreshData] = useState({});
  const [obrisiDok, setObrisiDok] = useState({
    id: null,
    disabled: false,
  });
  // sa komponente se salje id i disabled true/false
  const [disableBtn, setDisableBtn] = useState({
    id: null,
    disabled: false,
  });

  const [disableBtnNovi, setDisableBtnNovi] = useState({
    id: null,
    disabled: false,
  });

  const [disableBtnNovaMasina, setDisableBtnNovaMasina] = useState({
    id: null,
    disabled: false,
  });
  const [stampa, setStampa] = useState(false);
  const [template, setTemplate] = useState(false);
  const [info, setInfo] = useState(false);
  const [novi, setNovi] = useState(false);
  const [novaMasina, setNovaMasina] = useState(false);
  const [save, setSave] = useState(false);
  const [posalji, setPosalji] = useState(false);
  const [disablePosalji, setDisablePosalji] = useState(false);
  const [disableDetail, setDisableDetail] = useState(false);
  const [deklaracije, setDeklaracije] = useState(false);
  const [osvezi, setOsvezi] = useState(false);
  const [logo, setLogo] = useState(false);
  const [stavka, setStavka] = useState(false);
  const [disableStavka, setDisableStavka] = useState(false);
  const [promenaStatusa, setPromenaStatusa] = useState(false);
  const [disablePromenaStatusa, setDisablePromenaStatusa] = useState(false);
  const [prikaziSve, setPrikaziSve] = useState(false);
  const [matricaVestina, setMatricaVestina] = useState(false);
  const [disableMatricaVestina, setDisableMatricaVestina] = useState(false);
  const [matricaZapisa, setMatricaZapisa] = useState(false);
  const [disableMatricaZapisa, setDisableMatricaZapisa] = useState(false);
  const [pregledPlana, setPregledPlana] = useState(false);
  const [disablePregledPlana, setDisablePregledPlana] = useState(false);
  const [mesecniPlan, setMesecniPlan] = useState(false);
  const [disableMesecniPlan, setDisableMesecniPlan] = useState(false);
  const [ostvareniPlan, setOstvareniPlan] = useState(false);
  const [disableOstvareniPlan, setDisableOstvareniPlan] = useState(false);
  const [izmenaPlana, setIzmenaPlana] = useState(false);
  const [disableIzmenaPlana, setDisableIzmenaPlana] = useState(false);
  const [planPoseta, setPlanPoseta] = useState(false);
  const [disablePlanPoseta, setDisablePlanPoseta] = useState(false);
  const [dodajAtribut, setDodajAtribut] = useState(false);
  const [disableDodajAtribut, setDisableDodajAtribut] = useState(false);
  const [noviRadniNalog, setNoviRadniNalog] = useState(false);
  const [shop, setShop] = useState(false);
  const [detail, setDetail] = useState(false);
  const [dataNumberOfArticles, setDataNumberOfArticles] = useState(0);
  const [dodeliZaposlenima, setDodeliZaposlenima] = useState(false);
  const [disableDodeliZaposlenima, setDisableDodeliZaposlenima] =
    useState(false);
  const [dnevnik, setDnevnik] = useState(false);
  const [beleske, setBeleske] = useState(false);
  const [izvestaji, setIzvestaji] = useState(false);
  const [disabledIzvestaji, setDisabledIzvestaji] = useState(false);
  const [kreirajDokument, setKreirajDokument] = useState(false);
  const [pdfIzvestaj, setPdfIzvestaj] = useState(false);
  const [disableKreirajDokument, setDisableKreirajDokument] = useState({
    id: null,
    disabled: false,
  });

  const {
    data,
    error,
    isLoading,
    sendRequest,
    isSuccess,
    clearError,
    isOdobren,
    isDeleted,
    isStorniran,
    // disabledBtn,
    onSetData,
  } = useHttp('');
  const handleLogo = (data) => setLogo(data);
  const handleStavka = (data) => setStavka(data);
  const handleOsvezi = (data) => setOsvezi(data);
  const handleData = (data) => setButtonData(data);
  const handleRefreshData = (data) => setRefreshData(data);
  const handleObrisiDok = (data) => setObrisiDok(data);
  const handleDisableBtn = (data) => setDisableBtn(data);
  const handleDisableBtnNovi = (data) => setDisableBtnNovi(data);
  const handleDisableBtnNovaMasina = (data) => setDisableBtnNovaMasina(data);
  const handleStampa = (data) => setStampa(data);
  const handleTemplate = (data) => setTemplate(data);
  const handleInfo = (data) => setInfo(data);
  const handleNovi = (data) => setNovi(data);
  const handleNovaMasina = (data) => setNovaMasina(data);
  const handleSave = (data) => setSave(data);
  const handlePosalji = (data) => setPosalji(data);
  const handleDisablePosalji = (data) => setDisablePosalji(data);
  const handleDisableDetail = (data) => setDisableDetail(data);
  const handleDeklaracije = (data) => setDeklaracije(data);
  const handleDisablelogo = (data) => setDisableLogo(data);
  const handleDisableDeklaracije = (data) => setDisableDeklaracije(data);
  const handlePromenaStatusa = (data) => setPromenaStatusa(data);
  const handleDisablePromenaStatusa = (data) => setDisablePromenaStatusa(data);
  const handleDisableStavka = (data) => setDisableStavka(data);
  const handlePrikaziSve = (data) => setPrikaziSve(data);
  const handleMatricaVestina = (data) => setMatricaVestina(data);
  const handleDisableMatricaVestina = (data) => setDisableMatricaVestina(data);
  const handleMatricaZapisa = (data) => setMatricaZapisa(data);
  const handleDisableMatricaZapisa = (data) => setDisableMatricaZapisa(data);
  const handlePregledPlana = (data) => setPregledPlana(data);
  const handleDisablePregledPlana = (data) => setDisablePregledPlana(data);
  const handleMesecniPlan = (data) => setMesecniPlan(data);
  const handleDisableMesecniPlan = (data) => setDisableMesecniPlan(data);
  const handleOstvareniPlan = (data) => setOstvareniPlan(data);
  const handleDisableOstvareniPlan = (data) => setDisableOstvareniPlan(data);
  const handleIzmenaPlana = (data) => setIzmenaPlana(data);
  const handleDisableIzmenaPlana = (data) => setDisableIzmenaPlana(data);
  const handlePlanPoseta = (data) => setPlanPoseta(data);
  const handleDisablePlanPoseta = (data) => setDisablePlanPoseta(data);
  const handleDodajAtribut = (data) => setDodajAtribut(data);
  const handleDisableDodajAtribut = (data) => setDisableDodajAtribut(data);
  const handleNoviRadniNalog = (data) => setNoviRadniNalog(data);
  const handleShop = (data) => setShop(data);
  const handleDetail = (data) => setDetail(data);
  const handleDodeliZaposlenima = (data) => setDodeliZaposlenima(data);
  const handleDisableDodeliZaposlenima = (data) =>
    setDisableDodeliZaposlenima(data);
  const handleDnevnik = (data) => setDnevnik(data);
  const handleBeleske = (data) => setBeleske(data);
  const numberOfArticles = (data) => setDataNumberOfArticles(data);
  const handleIzvestaji = (data) => setIzvestaji(data);
  const handleDisableIzvestaji = (data) => setDisabledIzvestaji(data);
  const handleKreirajDokument = (data) => setKreirajDokument(data);
  const handleDisableKreirajDokument = (data) =>
    setDisableKreirajDokument(data);
  const handlePdfIzvestaj = (data) => setPdfIzvestaj(data);
  return (
    <div style={{ marginLeft: '5px', height: '100%', display: 'flex' }}>
      <ActiveComponent
        handleData={handleData}
        data={data}
        sendRequest={sendRequest}
        isLoading={isLoading}
        error={error}
        handleRefreshData={handleRefreshData}
        isSuccess={isSuccess}
        clearError={clearError}
        handleObrisiDok={handleObrisiDok}
        obrisiDok={obrisiDok}
        isOdobren={isOdobren}
        isDeleted={isDeleted}
        isStorniran={isStorniran}
        handleDisableBtn={handleDisableBtn}
        handleDisableBtnNovi={handleDisableBtnNovi}
        handleDisableBtnNovaMasina={handleDisableBtnNovaMasina}
        onSetData={onSetData}
        handleStampa={handleStampa}
        stampa={stampa}
        handleTemplate={handleTemplate}
        template={template}
        info={info}
        handleInfo={handleInfo}
        novi={novi}
        handleNovi={handleNovi}
        save={save}
        handleSave={handleSave}
        handleOsvezi={handleOsvezi}
        osvezi={osvezi}
        handleDeklaracije={handleDeklaracije}
        deklaracije={deklaracije}
        handleDisableDeklaracije={handleDisableDeklaracije}
        disableDeklaracije={disableDeklaracije}
        handleDisablelogo={handleDisablelogo}
        disableLogo={disableLogo}
        handleLogo={handleLogo}
        disableStavka={disableStavka}
        logo={logo}
        handlePromenaStatusa={handlePromenaStatusa}
        promenaStatusa={promenaStatusa}
        handleDisablePromenaStatusa={handleDisablePromenaStatusa}
        handleDisableStavka={handleDisableStavka}
        stavka={stavka}
        handleStavka={handleStavka}
        prikaziSve={prikaziSve}
        handlePrikaziSve={handlePrikaziSve}
        matricaVestina={matricaVestina}
        handleMatricaVestina={handleMatricaVestina}
        handleDisableMatricaVestina={handleDisableMatricaVestina}
        matricaZapisa={matricaZapisa}
        handleMatricaZapisa={handleMatricaZapisa}
        handleDisableMatricaZapisa={handleDisableMatricaZapisa}
        pregledPlana={pregledPlana}
        handlePregledPlana={handlePregledPlana}
        handleDisablePregledPlana={handleDisablePregledPlana}
        mesecniPlan={mesecniPlan}
        handleMesecniPlan={handleMesecniPlan}
        handleDisableMesecniPlan={handleDisableMesecniPlan}
        ostvareniPlan={ostvareniPlan}
        handleOstvareniPlan={handleOstvareniPlan}
        handleDisableOstvareniPlan={handleDisableOstvareniPlan}
        izmenaPlana={izmenaPlana}
        handleIzmenaPlana={handleIzmenaPlana}
        handleDisableIzmenaPlana={handleDisableIzmenaPlana}
        planPoseta={planPoseta}
        handlePlanPoseta={handlePlanPoseta}
        handleDisablePlanPoseta={handleDisablePlanPoseta}
        dodajAtribut={dodajAtribut}
        handleDodajAtribut={handleDodajAtribut}
        disableDodajAtribut={disableDodajAtribut}
        handleDisableDodajAtribut={handleDisableDodajAtribut}
        disableDodeliZaposlenima={disableDodeliZaposlenima}
        handleDisableDodeliZaposlenima={handleDisableDodeliZaposlenima}
        handlePosalji={handlePosalji}
        posalji={posalji}
        handleDisablePosalji={handleDisablePosalji}
        handleDisableDetail={handleDisableDetail}
        handleNovaMasina={handleNovaMasina}
        novaMasina={novaMasina}
        noviRadniNalog={noviRadniNalog}
        handleNoviRadniNalog={handleNoviRadniNalog}
        shop={shop}
        handleShop={handleShop}
        detail={detail}
        handleDetail={handleDetail}
        numberOfArticles={numberOfArticles}
        dodeliZaposlenima={dodeliZaposlenima}
        handleDodeliZaposlenima={handleDodeliZaposlenima}
        dnevnik={dnevnik}
        beleske={beleske}
        handleDnevnik={handleDnevnik}
        handleBeleske={handleBeleske}
        izvestaji={izvestaji}
        handleIzvestaji={handleIzvestaji}
        handleDisableIzvestaji={handleDisableIzvestaji}
        kreirajDokument={kreirajDokument}
        handleKreirajDokument={handleKreirajDokument}
        disableKreirajDokument={disableKreirajDokument}
        handleDisableKreirajDokument={handleDisableKreirajDokument}
        pdfIzvestaj={pdfIzvestaj}
        handlePdfIzvestaj={handlePdfIzvestaj}
      />
      <Buttons
        data={buttonData}
        sendRequest={sendRequest}
        refreshData={refreshData}
        // disabledBtn={disabledBtn} // direknto nakon odobravanja ili storniranja
        disableBtn={disableBtn} // dolazi sa komponente
        disableBtnNovi={disableBtnNovi}
        handleObrisiDok={handleObrisiDok}
        handleStampa={handleStampa}
        handleTemplate={handleTemplate}
        handleInfo={handleInfo}
        handleNovi={handleNovi}
        handleSave={handleSave}
        handleDeklaracije={handleDeklaracije}
        disableDeklaracije={disableDeklaracije}
        handleOsvezi={handleOsvezi}
        disableLogo={disableLogo}
        handleDisableStavka={handleDisableStavka}
        handleStavka={handleStavka}
        handleLogo={handleLogo}
        disableStavka={disableStavka}
        handlePromenaStatusa={handlePromenaStatusa}
        disablePromenaStatusa={disablePromenaStatusa}
        handlePrikaziSve={handlePrikaziSve}
        handleMatricaVestina={handleMatricaVestina}
        disableMatricaVestina={disableMatricaVestina}
        handleDisableMatricaVestina={handleDisableMatricaVestina}
        handleMatricaZapisa={handleMatricaZapisa}
        disableMatricaZapisa={disableMatricaZapisa}
        handleDisableMatricaZapisa={handleDisableMatricaZapisa}
        pregledPlana={pregledPlana}
        handlePregledPlana={handlePregledPlana}
        disablePregledPlana={disablePregledPlana}
        handleDisablePregledPlana={handleDisablePregledPlana}
        mesecniPlan={mesecniPlan}
        handleMesecniPlan={handleMesecniPlan}
        disableMesecniPlan={disableMesecniPlan}
        handleDisableMesecniPlan={handleDisableMesecniPlan}
        ostvareniPlan={ostvareniPlan}
        handleOstvareniPlan={handleOstvareniPlan}
        disableOstvareniPlan={disableOstvareniPlan}
        handleDisableOstvareniPlan={handleDisableOstvareniPlan}
        izmenaPlana={izmenaPlana}
        handleIzmenaPlana={handleIzmenaPlana}
        disableIzmenaPlana={disableIzmenaPlana}
        handleDisableIzmenaPlana={handleDisableIzmenaPlana}
        planPoseta={planPoseta}
        disablePlanPoseta={disablePlanPoseta}
        handlePlanPoseta={handlePlanPoseta}
        handleDisablePlanPoseta={handleDisablePlanPoseta}
        handleDodajAtribut={handleDodajAtribut}
        disableDodajAtribut={disableDodajAtribut}
        handleDisableDodajAtribut={handleDisableDodajAtribut}
        disableDodeliZaposlenima={disableDodeliZaposlenima}
        handleDisableDodeliZaposlenima={handleDisableDodeliZaposlenima}
        disablePosalji={disablePosalji}
        disableDetail={disableDetail}
        handlePosalji={handlePosalji}
        handleNovaMasina={handleNovaMasina}
        handleNoviRadniNalog={handleNoviRadniNalog}
        handleShop={handleShop}
        handleDetail={handleDetail}
        dataNumberOfArticles={dataNumberOfArticles}
        numberOfArticles={numberOfArticles}
        disableBtnNovaMasina={disableBtnNovaMasina}
        handleDodeliZaposlenima={handleDodeliZaposlenima}
        handleDnevnik={handleDnevnik}
        handleBeleske={handleBeleske}
        izvestaji={izvestaji}
        disabledIzvestaji={disabledIzvestaji}
        handleIzvestaji={handleIzvestaji}
        handleDisableIzvestaji={handleDisableIzvestaji}
        handleKreirajDokument={handleKreirajDokument}
        disableKreirajDokument={disableKreirajDokument}
        handleDisableKreirajDokument={handleDisableKreirajDokument}
        handlePdfIzvestaj={handlePdfIzvestaj}
      />
    </div>
  );
}

export default Wrapper;
